import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function FilterSection() {
  return <section className="py-24 px-4 bg-bg-card border-y border-border-color" data-id="element-26">
      <div className="container max-w-6xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-27">
        {/* For You */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-bg-primary rounded-2xl p-8 border border-cta-primary/30 shadow-[0_0_30px_rgba(34,197,94,0.05)]" data-id="element-28">
          <h3 className="text-2xl font-heading font-bold text-text-primary mb-8 flex items-center" data-id="element-29">
            <span className="bg-cta-primary/20 text-cta-primary p-2 rounded-lg mr-3" data-id="element-30">
              <Check className="w-6 h-6" data-id="element-31" />
            </span>
            Esto es para ti si…
          </h3>
          <ul className="space-y-6" data-id="element-32">
            {['Sos hombre y querés mejorar tu presencia sin actuar ni ser fake.', 'Te cuesta ser consistente: un día bien, otro día inseguro.', 'Querés conexión real, no juegos.', 'Estás listo para practicar 15–20 min al día.'].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-33">
                <Check className="w-5 h-5 text-cta-primary mt-1 flex-shrink-0" data-id="element-34" />
                <span className="text-text-normal" data-id="element-35">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Not For You */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-bg-primary rounded-2xl p-8 border border-red-500/30 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-36">
          <h3 className="text-2xl font-heading font-bold text-text-primary mb-8 flex items-center" data-id="element-37">
            <span className="bg-red-500/20 text-red-500 p-2 rounded-lg mr-3" data-id="element-38">
              <X className="w-6 h-6" data-id="element-39" />
            </span>
            Esto NO es para ti si…
          </h3>
          <ul className="space-y-6" data-id="element-40">
            {['Buscás manipular o lastimar a alguien.', 'Querés resultados sin mover un dedo.', 'Querés un truco en vez de mejorar tu base.'].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-41">
                <X className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" data-id="element-42" />
                <span className="text-text-normal" data-id="element-43">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}